import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

// Boîte de confirmation stylée (remplace window.confirm) — item = { label, program_label?, category? }
export function ConfirmDeleteDialog({ item, onConfirm, onCancel, busy }) {
  return (
    <AlertDialog open={!!item} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent className="bg-zinc-950 border border-rose-500/40 text-zinc-100 max-w-md" data-testid="confirm-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-base flex items-center gap-2 text-rose-300">🗑 Supprimer cet article ?</AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-zinc-400">
            <span className="block rounded-lg border border-zinc-800 bg-zinc-900/70 px-3 py-2 mt-1 mb-2 text-zinc-100 font-semibold" data-testid="confirm-delete-item-name">{item?.label}</span>
            {item?.reason && <span className="block text-xs text-zinc-500 mb-1">Raison : {item.reason}</span>}
            L'article ira dans la <b className="text-amber-300">corbeille</b> (« Supprimés récemment ») — tu pourras le restaurer en 1 clic avec les statuts élèves associés.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-zinc-800 border-zinc-700 text-zinc-200 hover:bg-zinc-700 hover:text-zinc-100" data-testid="confirm-delete-cancel">Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={busy} className="bg-rose-600 hover:bg-rose-500 text-white" data-testid="confirm-delete-confirm">{busy ? "…" : "Supprimer"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
